import styled from 'styled-components';
import { media } from 'utils/style';

import Orders from './Orders';

export default styled(Orders)`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100%;
  flex-grow: 1;

  ${media.lessThan('medium')`
    overflow-y: auto;
`};
`;
